<!-- 平台查看多控销售统计 -- tabs -->
<template>
    <div class="pl-sales-statistic-tabs">
        <div class="header-content">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="item.label" :name="item.name" v-for="(item, index) in tabList"
                    :key="index"></el-tab-pane>
            </el-tabs>
            <div class="btns">
                <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
                <el-button type="default" size="small" @click="handleReset">重置</el-button>
                <el-button type="primary" size="small" @click="handleExport">导出</el-button>
            </div>
        </div>
        <div class="divider"></div>
        <el-form ref="searchForm" :inline="true" :model="searchForm">
            <el-form-item>
                <el-input v-model="searchForm.name" placeholder="产品线名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input v-model="searchForm.goodsName" placeholder="产品名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input v-model="searchForm.cooperationName" placeholder="合作代理"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input v-model="searchForm.teamName" placeholder="合作团队"></el-input>
            </el-form-item>
            <el-form-item>
                <!-- <el-input v-model="searchForm.district" placeholder="所属组织层级"></el-input> -->
                <!-- 远程搜索 -->
                <el-select v-model="searchForm.district" filterable remote reserve-keyword placeholder="请输入所属组织层级"
                    :remote-method="remoteMethod" clearable>
                    <el-option v-for="item in filterEnum" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-input v-model="searchForm.salesUserName" placeholder="所属业务员"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input v-model="searchForm.orderCode" placeholder="订单编号"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input v-model="searchForm.shopName" placeholder="客户名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-select v-model="searchForm.bagType" placeholder="产品线分类" clearable style="width: 120px;">
                    <el-option label="商控" value="1"></el-option>
                    <el-option label="绝对控制" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="searchForm.orderStatus" placeholder="订单状态" clearable style="width: 120px;">
                    <el-option label="待付款" value="1"></el-option>
                    <el-option label="待发货" value="2"></el-option>
                    <el-option label="配送中" value="3"></el-option>
                    <el-option label="已签收" value="8"></el-option>
                    <el-option label="已完成" value="9"></el-option>
                    <el-option label="审核中" value="11"></el-option>
                    <el-option label="待确款" value="12"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="searchForm.provinceName" @change="provinceBtn" placeholder="请选择省" clearable
                    style="width: 126px" @clear="handleClearProvince">
                    <el-option v-for="(item, index) in provinceData" :key="index" :label="item.rname"
                        :value="item.rname" />
                </el-select>
                <el-select v-model="searchForm.cityName" placeholder="请选择市" @change="cityBtn" clearable
                    style="margin-left: 12px; width: 126px" @clear="handleClearCity">
                    <el-option v-for="(item, index) in cityData" :key="index" :label="item.rname" :value="item.rname" />
                </el-select>
                <el-select v-model="searchForm.areaName" placeholder="请选择区" @change="areaBtn" clearable
                    style="margin-left: 11px; width: 126px" @clear="handleClearArea">
                    <el-option v-for="(item, index) in areaData" :key="index" :label="item.rname" :value="item.rname" />
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="searchForm.isSettled" placeholder="结算状态" clearable style="width: 126px">
                    <el-option label="未结算" value="0"></el-option>
                    <el-option label="已结算" value="1"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-form ref="searchFormTimeDate" :inline="true" :model="searchForm">
            <el-form-item label="下单时间">
                <el-date-picker v-model="searchForm.orderTime" type="datetimerange" range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="rangePickerOptions" />
            </el-form-item>
            <el-form-item label="完成收货时间">
                <el-date-picker v-model="searchForm.finishTime" type="datetimerange" range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="rangePickerOptions" />
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import {
    regionProvince,
    regionCity,
    regionArea,
} from "@/api/merchantsettlement/index";
import {
    queryAdTeamLevelNameSearchForAgent
} from '@/api/saleRule/productLine'
import dayjs from 'dayjs'
export default {
    name: 'PlSalesStatisticTabs',
    components: {

    },
    data() {
        return {
            activeName: '1',
            tabList: [{
                label: '商品统计',
                name: '1'
            }],
            searchForm: {
                name: '',
                goodsName: '',
                cooperationName: '',
                teamName: '',
                district: '',
                salesUserName: '',
                orderCode: '',
                shopName: '',
                bagType: '',
                provinceName: '',
                cityName: '',
                areaName: '',
                city: '',
                area: '',
                province: '',
                isSettled: '',
                orderStatus: '',
                orderTime: [dayjs().subtract(1, 'month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],//默认一个月时间
                finishTime: [],
            },
            provinceData: [],
            cityData: [],
            areaData: [],
            querString: '',
            filterEnum: [],
            rangePickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }],
                onPick: ({ minDate }) => {
                    if (minDate) {
                        this.rangePickerOptions.minDate = minDate;
                    }
                },
                disabledDate: (time) => {
                    const today = new Date();
                    today.setHours(23, 59, 59, 999); // 包含今天

                    // 1. 首先限制所有日期不超过今天
                    if (time.getTime() > today.getTime()) {
                        return true;
                    }

                    // 2. 如果已选择开始日期，则限制范围在1个月内
                    if (this.rangePickerOptions.minDate) {
                        const maxDate = new Date(this.rangePickerOptions.minDate);
                        maxDate.setMonth(maxDate.getMonth() + 1);

                        const minDate = new Date(this.rangePickerOptions.minDate);
                        minDate.setMonth(minDate.getMonth() - 1);

                        return time.getTime() > maxDate.getTime() ||
                            time.getTime() < minDate.getTime();
                    }

                    return false;
                }
            }
        }
    },
    created() {
        this.initPosition()
    },
    methods: {
        handleClick() {
            console.log('click')
        },
        initPosition(info) {
            regionProvince()
                .then((res) => {
                    if (res.code === 0) {
                        this.provinceData = res.data;
                    }
                })
        },
        handleClearProvince() {
            this.searchForm.province = "";
            this.searchForm.city = "";
            this.searchForm.area = "";
        },
        handleClearCity() {
            this.searchForm.city = "";
            this.searchForm.area = "";
        },
        handleClearArea() {
            this.searchForm.area = "";
        },
        provinceBtn(item) {
            this.cityData = [];
            this.areaData = [];
            if (!item) {
                this.searchForm.city = ``;
                this.searchForm.area = ``;
                this.searchForm.cityName = "";
                this.searchForm.areaName = "";
            } else {
                const provinceFindCode = this.provinceData.find(p => p.rname === item).id;
                this.searchForm.province = provinceFindCode
                this.searchForm.cityName = "";
                this.searchForm.areaName = "";
                regionCity(provinceFindCode).then((res) => {
                    this.cityData = res.data;
                });
            }
        },
        cityBtn(item) {
            this.areaData = [];
            if (!item) {
                this.searchForm.areaName = "";
            } else {
                const city = this.cityData.find(c => c.rname === item).id
                regionArea(city).then((res) => {
                    this.searchForm.areaName = "";
                    this.searchForm.city = city
                    this.areaData = res.data;
                });
            }
        },
        areaBtn(item) {
            if (!item) {
            } else {
                this.searchForm.area = this.areaData.find(a => a.rname === item).id
            }
        },
        getParams() {
            let params = { ...this.searchForm }
            if (params.orderTime && params.orderTime.length > 1) {
                params['startTime'] = dayjs(params.orderTime[0]).format('YYYY-MM-DD HH:mm:ss')
                params['endTime'] = dayjs(params.orderTime[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            if (params.finishTime && params.finishTime.length > 1) {
                params['finishStartTime'] = dayjs(params.finishTime[0]).format('YYYY-MM-DD HH:mm:ss')
                params['finishEndTime'] = dayjs(params.finishTime[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            // 去掉没值的属性
            for (let key in params) {
                if (params[key] === '' || params[key] === undefined) {
                    delete params[key]
                }
            }
            delete params.orderTime
            delete params.finishTime
            return params
        },
        handleSearch() {
            const params = this.getParams()
            if (!params.startTime && !params.finishStartTime) {
                this.$message.error('请选择时间范围')
                return;
            }
            this.$emit('search', params)
        },
        handleReset() {
            this.searchForm = {
                name: '',
                goodsName: '',
                cooperationName: '',
                teamName: '',
                district: '',
                salesUserName: '',
                orderCode: '',
                shopName: '',
                bagType: '',
                provinceName: '',
                cityName: '',
                areaName: '',
                city: '',
                area: '',
                province: '',
                isSettled: '',
                orderStatus: '',
            }
            this.handleSearch()
        },
        handleExport() {
            const params = this.getParams()
            this.$emit('export', params)
        },
        getTeamLevel() {
            queryAdTeamLevelNameSearchForAgent({
                searchKeywords: this.querString,
            }).then((res) => {
                if (res) {
                    let arr = []
                    res.forEach((item) => {
                        arr.push({
                            value: item,
                            label: item,
                        })
                    });
                    this.filterEnum = arr;
                }
            });
        },
        remoteMethod(query) {
            if (query !== '') {
                this.querString = query;
                this.getTeamLevel();
            }
        }
    }
}
</script>


<style scoped lang="scss">
.pl-sales-statistic-tabs {
    background-color: #fff;
    padding: 0px 10px;
    margin-top: 10px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    .header-content {
        display: flex;
        align-items: center;
    }

    .btns {
        margin-left: auto;
    }

    .divider {
        height: 6px;
    }
}
</style>